// @ts-ignore
const dateWithinReservation = (reservation) => (date) => {
    const res = reservation;
    const pickupDate = date;
    return res.__fromTimestamp <= pickupDate.getTime() && pickupDate.getTime() <= res.__toTimestamp;
};
export default dateWithinReservation;
